import { DesignSystem } from '@workbuddy/ui/v2/design-system';

const tokens = DesignSystem.tokens;

export const formHostStyleId = 'wb-v2-surface-form-host-theme';

export const formHostBridgeStyles = {
  'wb-surface-form-host': {
    // Dialog / submit forms: plain page surface.
    '--local-form-canvas-bg': tokens.color.background.primary,
    // Patch forms embedded under Manage formDefinition tabs: same canvas as Manage form tabs.
    '--local-form-canvas-bg-patch': 'var(--colors-background-card-section)',
    '--local-form-gap': tokens.spacing.lg,
    '--local-form-padding-y': tokens.spacing.xl,
    '--local-form-padding-x': tokens.spacing.xl,
    // Last row must clear the footer/panel edge when the body is scrolled to the end.
    '--local-form-padding-bottom': tokens.spacing.fourXl,
    '--local-form-footer-gap': tokens.spacing.md,
    '--local-form-footer-padding-y': tokens.spacing.lg,
    '--local-form-footer-padding-x': tokens.spacing.xl,
    '--local-form-footer-border': tokens.color.border.secondary,

    '--local-form-scrollbar-size': '6px',
    '--local-form-scrollbar-thumb': tokens.color.border.primary,
    '--local-form-scrollbar-thumb-hover': tokens.color.border.secondaryAlt,
    '--local-form-scrollbar-track': 'transparent',
    '--local-form-scrollbar-radius': tokens.radius.full,

    '--local-form-error-bg': tokens.color.background.errorPrimary,
    '--local-form-error-border': tokens.color.border.error,
    '--local-form-error-text': tokens.color.text.errorPrimary,
    '--local-form-error-radius': tokens.radius.md,
    '--local-form-banner-padding-y': tokens.spacing.md,
    '--local-form-banner-padding-x': tokens.spacing.lg,

    // Delegated dialog title bar: same values as entity.dialog.host.theme's create header.
    '--local-form-dialog-header-height': '48px',
    '--local-form-dialog-header-pad-x': tokens.spacing.md,
    '--local-form-dialog-header-gap': tokens.spacing.sm,
    '--local-form-dialog-header-border': tokens.color.border.secondary,
    '--local-form-dialog-title-size': tokens.font.size.textMdBase,
    '--local-form-dialog-title-weight': tokens.font.weight.semibold,
    '--local-form-dialog-title-line': tokens.lineHeight.textMd,
    '--local-form-dialog-title-color': tokens.color.text.primary,
    '--local-form-dialog-close-size': '24px',
    '--local-form-dialog-close-color': tokens.color.text.secondary,
    '--local-form-dialog-close-hover': tokens.color.text.primary,
  },
  // Submit dialogs (Task create): Figma body is 20 / 20, not the denser 16 / 12 default.
  'wb-surface-form-host[data-save-strategy="submit"]': {
    '--local-form-gap': tokens.spacing.twoXl,
    '--local-form-padding-y': tokens.spacing.twoXl,
    '--local-form-padding-x': tokens.spacing.twoXl,
    '--local-form-padding-bottom': tokens.spacing.fourXl,
    '--local-form-footer-padding-x': tokens.spacing.twoXl,
    '--local-form-column-border': tokens.color.border.secondary,
    '--local-form-column-border-width': tokens.borderWidth.sm,
    // Submit Forms are action dialogs: section headings need a clear step hierarchy.
    '--local-form-section-title-size': tokens.font.size.textLg,
    '--local-form-section-title-weight': tokens.font.weight.semibold,
  },
};

export function mountFormHostTheme(document: Document): void {

  DesignSystem.Mount(document, formHostStyleId, formHostBridgeStyles);
}
